import firebase from 'firebase';
import _ from 'lodash';

import View from '../_components/view/view.js';
import newsSectionTpl from './news-section.tpl.html';
import './news-section.styles.less';

import NewsItemView from './news-item/news-item.view.js';

class NewsSectionView extends View {

	constructor (data, options) {
		let viewOptions = {
			viewClass: 'news-section'
		};

		super(newsSectionTpl, data, _.extend(options, viewOptions));

		this.newsViews = [];
		this.newsRef = firebase.database().ref('news/');
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			newsList: '.news-list',
			loaderContainer: '.loader-container'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		//UI Events
		

		///Database Events
		this.newsRef.on('value', __news => {
			this.updateNewsList(__news);
			this.ui.loaderContainer.addClass('hidden');
			this.ui.newsList.removeClass('hidden');
		});
			
	}

	updateNewsList(__news) {
		this.removeNewsList();

		__news.forEach( __new => {
			let
			newView = new NewsItemView(__new.val(), {__new: __new});
			this.newsViews.unshift(newView);
		});

		this.newsViews.forEach((view) => {
			view.appendTo(this.ui.newsList);
		});
	}

	removeNewsList() {
		_.forEach(this.newsViews, newView => {
			newView.remove();
		});

		this.newsViews = [];
	}

	remove() {
		this.removeNewsList();
		super.remove();
	}

}

export default NewsSectionView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/news-section/news-section.view.js